import React from "react";
import { connect } from "react-redux";
import Loading from "@Components/Icons/Loading";
import { addNotification } from "@Store/Actions/Notifications";
import { boot } from "@Store/Actions/Auth";
import Login from "./Login";
import MFA from "./MFA";
class LoginController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            processingToken: false,
        };
    }
    async componentDidMount() {
        const queryParameters = new URLSearchParams(location.search);
        const urlToken = queryParameters.get("token") || "";
        if (urlToken !== "") {
            const token = urlToken.replaceAll(":", ".");
            localStorage.setItem("token", token);
            sessionStorage.setItem("currentToken", token);
            this.setState({ processingToken: true });
            await this.props.boot().finally(() => {
                this.setState({ processingToken: false });
            });
        }
    }
    render() {
        if (this.state.processingToken) {
            return (React.createElement("div", null,
                React.createElement(Loading, { size: "3rem" })));
        }
        if (this.props.token &&
            this.props.user?.mfaEnabled &&
            !this.props.mfa &&
            !this.props.user?.assumed) {
            return React.createElement(MFA, null);
        }
        return React.createElement(Login, null);
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        // dispatching plain actions
        boot: () => boot(dispatch),
        notify: (data) => addNotification(dispatch, data),
    };
};
const mapStateToProps = ({ auth: { token, user, mfa } }) => ({
    mfa,
    token,
    user,
});
export default connect(mapStateToProps, mapDispatchToProps)(LoginController);
